import { PROVIDERS } from '../../env';

export const ANALYTICS_MODULES = {
  CASH: 'cash',
  OPERATIONS: 'operations',
  OVERVIEW: 'overview',
  PROMO: 'promo',
  RESERVATIONS: 'reservations',
  SALES: 'sales',
  ORDERS: 'orders',
};

export const DONUT_TYPE = {
  NUMBER: 'number',
  PERCENTAGE: 'percentage',
  CURRENCY: 'currency',
};

export const DOWNLOAD_FILE_TYPE = {
  CSV: 'CSV',
  XLSX: 'XLSX',
};

export const PROVIDER_COLORS = {
  [PROVIDERS.KLIKIT]: '#6A13F4',
  [PROVIDERS.UBEREATS]: '#57BD71',
  [PROVIDERS.DELIVEROO]: '#2596BE',
  [PROVIDERS.JUSTEAT]: '#F39F18',
  [PROVIDERS.DOORDASH]: '#E75637',
  [PROVIDERS.GRABFOOD]: '#269342',
  [PROVIDERS.FOODPANDA]: '#DE2673',
  [PROVIDERS.SHOPIFY]: '#8673A1',
  [PROVIDERS.GOFOOD]: '#FF0B0B',
  [PROVIDERS.ODDLE]: '#3B0693',
  [PROVIDERS.SHOPEE]: '#FF8F0B',
  12: '#F37934',
  [PROVIDERS.PICKAROO]: '#1DE1CE',
  [PROVIDERS.WOLT]: '#00C2E8',
  [PROVIDERS.SQUARE]: '#000000',
  [PROVIDERS.TIKTOK]: '#25F4EE',
};

export const COMPARISON_TYPE = {
  AGGREGATOR: 'provider_id',
  BRAND: 'brand_id',
  BRANCH: 'branch_id',
};

export const DATE_FILTER_DAY_LIMIT = 365;

export const HOUR_LIST = [
  { id: 0, title: '12:00 AM' },
  { id: 100, title: '01:00 AM' },
  { id: 200, title: '02:00 AM' },
  { id: 300, title: '03:00 AM' },
  { id: 400, title: '04:00 AM' },
  { id: 500, title: '05:00 AM' },
  { id: 600, title: '06:00 AM' },
  { id: 700, title: '07:00 AM' },
  { id: 800, title: '08:00 AM' },
  { id: 900, title: '09:00 AM' },
  { id: 1000, title: '10:00 AM' },
  { id: 1100, title: '11:00 AM' },
  { id: 1200, title: '12:00 PM' },
  { id: 1300, title: '01:00 PM' },
  { id: 1400, title: '02:00 PM' },
  { id: 1500, title: '03:00 PM' },
  { id: 1600, title: '04:00 PM' },
  { id: 1700, title: '05:00 PM' },
  { id: 1800, title: '06:00 PM' },
  { id: 1900, title: '07:00 PM' },
  { id: 2000, title: '08:00 PM' },
  { id: 2100, title: '09:00 PM' },
  { id: 2200, title: '10:00 PM' },
  { id: 2300, title: '11:00 PM' },
];

export const MODULE_LIST = [
  { key: ANALYTICS_MODULES.OVERVIEW, title: 'Overview', customClass: 'w-24' },
  { key: ANALYTICS_MODULES.SALES, title: 'Sales', customClass: 'w-20' },
  {
    key: ANALYTICS_MODULES.OPERATIONS,
    title: 'Operations',
    customClass: 'w-28',
  },
  { key: ANALYTICS_MODULES.PROMO, title: 'Promo', customClass: 'w-24' },
  { key: ANALYTICS_MODULES.ORDERS, title: 'Orders', customClass: 'w-24' },
  { key: ANALYTICS_MODULES.CASH, title: 'Cash', customClass: 'w-20' },
  // {
  //   key: ANALYTICS_MODULES.RESERVATIONS,
  //   title: 'Reservations',
  //   customClass: 'w-32',
  // },
];

export const OOS_ANALYTICS_TYPES = [
  { key: 'report', title: 'OOS Report' },
  { key: 'logs', title: 'OOS Logs' },
];

export const OOS_ENTITY_TYPES = [
  { key: 'item', title: 'Item' },
  { key: 'modifier', title: 'Modifier' },
];

export const OWN_CHANNELS = [
  { title: 'Add Order', id: 'm', slug: 'm' },
  { title: 'Webshop', id: 'w', slug: 'w' },
  { title: 'Fast Charge', id: 's', slug: 's' },
];

export const OWN_CHANNEL_TITLES = {
  m: 'Add Order',
  w: 'Webshop',
  s: 'Fast Charge',
};

export const RANDOM_COLORS = [
  '#e6194b',
  '#3cb44b',
  '#ffe119',
  '#0082c8',
  '#f58231',
  '#911eb4',
  '#46f0f0',
  '#f032e6',
  '#d2f53c',
  '#fabebe',
  '#008080',
  '#e6beff',
  '#aa6e28',
  '#fffac8',
  '#800000',
  '#aaffc3',
  '#808000',
  '#ffd8b1',
  '#000080',
  '#808080',
  '#FFFFFF',
  '#000000',
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FFFF00',
  '#00FFFF',
  '#FF00FF',
  '#800080',
  '#800000',
  '#008000',
  '#808000',
  '#000080',
  '#008080',
  '#C0C0C0',
  '#FFA07A',
  '#20B2AA',
  '#87CEFA',
  '#778899',
  '#B0C4DE',
  '#32CD32',
  '#FA8072',
  '#40E0D0',
  '#DA70D6',
  '#FF1493',
  '#7B68EE',
  '#00FA9A',
  '#ADFF2F',
  '#FF4500',
  '#6A5ACD',
  '#A0522D',
  '#5F9EA0',
  '#D2691E',
  '#9ACD32',
  '#9932CC',
  '#FF6347',
  '#4682B4',
  '#008B8B',
  '#B22222',
  '#FF8C00',
  '#8B008B',
  '#556B2F',
  '#BDB76B',
  '#8B0000',
  '#2F4F4F',
  '#00CED1',
  '#9400D3',
  '#7FFF00',
  '#DC143C',
  '#00BFFF',
  '#FF69B4',
  '#CD5C5C',
  '#483D8B',
  '#191970',
  '#FF7F50',
  '#6495ED',
  '#DEB887',
  '#A9A9A9',
  '#B8860B',
  '#006400',
  '#F0E68C',
  '#1E90FF',
  '#FFD700',
  '#2E8B57',
  '#DDA0DD',
  '#90EE90',
  '#4169E1',
  '#8A2BE2',
  '#F4A460',
  '#D8BFD8',
  '#9ACD32',
  '#6B8E23',
  '#A52A2A',
  '#00008B',
  '#A0522D',
  '#CD853F',
  '#DC143C',
  '#7CFC00',
  '#FFDEAD',
  '#228B22',
];

export const TIME_PERIOD_DAILY = { title: 'Daily', id: 'daily', slug: 'daily' };

export const TIME_PERIOD_LIST = [
  // { title: 'Hourly', id: 'hourly', slug: 'hourly' },
  TIME_PERIOD_DAILY,
  { title: 'Weekly', id: 'weekly', slug: 'weekly' },
  // { title: 'Monthly', id: 'monthly', slug: 'monthly' },
];

export const TOOLTIP_LABELS = {
  AGGREGATOR_COMPARISON_HELP:
    'When the Aggregator Comparison is toggled on, performance across different delivery aggregators are compared.',
  BRAND_COMPARISON_HELP:
    'When the Brand Comparison is toggled on, performance across different brands are compared.',
  BRANCH_COMPARISON_HELP:
    'When the Brand Comparison is toggled on, performance across different branches are compared.',
};
